<template>
    <ul>
        <li v-for="(pic, i) in gallery" :key="i">
            <div :class="{ pic: true, confirmed: true}">
                <div class="inner">
                    <p 
                        :style="maxWidthStyle" 
                        class="single-line-clamp" 
                        v-text="pic.name || pic"
                    />
                </div>
                <div class="actions">
                    <a class="bordered" download :href="pic.url" target="_blank">
                        <div class="icon eye_icon"></div>
                    </a>
                    <a class="remove" v-if="!watchOnly" @click="$emit('remove', pic)">
                        <div class="icon delete_icon"></div>
                    </a>
                </div> 
            </div>
        </li>
        <li class="upload" v-show="gallery.length === 0 && uploadboxs.length > 0 && !watchOnly" v-for="(box, index) in uploadboxs" :key="index">
            <div 
                class="pic" 
                @click="$emit('choose-files', index)"
                :class="{ 'is-dragover': box.isDragover }"
                @dragover.stop.prevent="handleDragover(index)"
                @dragenter.stop.prevent="handleDragover(index)"
                @dragleave.stop.prevent="handleDragleave(index)"
                @dragend.stop.prevent="handleDragleave(index)"
                @drop.stop.prevent="handleDrop($event, index)"
                @drag.stop.prevent
                @dragstart.stop.prevent
            >
                <div 
                    class="content" 
                    :class="{ uploading: box.isUploading }" 
                    :style="'--percentComplete: ' + box.percentComplete + '%;'"
                >
                    <p v-if="!box.isUploading" v-html="customLabel" />
                    <p v-else>בתהליך</p>
                    <div 
                        class="icon" 
                        :class="{
                            plus_circle_icon: isInputBox, 
                            upload_icon: !isInputBox
                        }"
                    />
                    <div class="progress" v-show="box.isUploading">
                        <div 
                            class="amount" 
                            :style="'width: ' + box.percentComplete + '%'"
                        />
                    </div>
                </div>
            </div>
        </li>
        <li class="add" v-show="!watchOnly && gallery.length > 0 && gallery.length < settings.max" @click="$emit('upload-directly')">
            <p>הוספת קובץ</p>
            <i class="fas fa-plus"></i>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'GalleryList',

    props: {
        gallery: {
            type: Array,
            required: true
        },
        settings: {
            type: Object,
            required: true
        },
        maxWidth: {
            type: Number,
            required: false
        },
        isInputBox: {
            type: Boolean,
            required: true
        },
        customLabel: {
            type: String,
            required: true
        },
        uploadboxs: {
            type: Array,
            required: true
        },
        watchOnly: {
            type: Boolean,
            default: false
        }
    },

    emits: ['choose-files', 'remove', 'drop', 'add-uploadbox', 'upload-directly', 'update-uploadbox'],

    data() {
        return {};
    },

    computed: {
        maxWidthStyle() {
            return this.maxWidth && this.maxWidth > 0 
                ? `max-width: ${this.maxWidth}px` 
                : '';
        }
    },

    methods: {
        handleDragover(index) {
            this.$emit('update-uploadbox', index, { isDragover: true });
        },

        handleDragleave(index) {
            this.$emit('update-uploadbox', index, { isDragover: false });
        },

        handleDrop(e, index) {
            this.$emit('update-uploadbox', index, { isDragover: false });
            this.$emit('drop', e, index);
        }
    }
};
</script>

<style lang="scss" scoped>
.single-line-clamp {
    line-clamp: 1;
    --webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

ul { width: 100%; height: 100%; display: flex; flex-direction: column; gap: 10px;

    li {  border-radius: 12px; border: 1px solid #B2C8D3; background: #fff; overflow: hidden;     min-height: 40px;
        @media (max-width: 600px) {
            &:not(:last-child) {
                border-bottom: 1px solid var(--4, #E6E9EF);
                border-radius: var(--radius);
            }
        }
        .content { display: flex; align-items: center; gap: 10px;

            .icon { width: 17px; height: 17px;}
        }

        &.upload { cursor: pointer; display: flex; align-items: center; justify-content: center;
            .pic {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                @media (max-width: 600px) {
                    padding-bottom: var(--gap_large);
                    padding-top: var(--gap_big);
                }
            }
            p { color: var(--ligth_color);}
        }

        &.add { cursor: pointer; border: 1.3px solid #4D7E99; display: flex;   align-items: center; height: 100%; justify-content: center; gap: 10px;
            p { font-size: 14px; color: var(--btn_color);     font-size: var(--h4);}
            svg, i { font-size: 20px; color: var(--dark_blue);}
        }
    }
}

.pic {
    padding-inline: 10px;
    height: 100%;
    width: 100%;
    display: flex;

    @media (max-width: 600px) {
        gap: 12px;
        padding: 15px;
    }

    &.confirmed {
        height: 100%;

        @media (min-width: 600px) {
            background: #4d7e994a;
        }
    }

    .inner {
        // background: #fff;
        overflow: hidden;
        display: flex !important;
        justify-content: center;
        align-items: center;
        // border-radius: 15px;
        padding: 8px;
        flex: 1;
    }

    .actions {
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: center;

        &:empty {
            display: none;
        }

        .remove {
            @media (max-width: 600px) {
                background-color: transparent;
                padding: 0;
            }

            @media (min-width: 600px) {
                color: #fff;
            }
        }
    }

    &.is-dragover {
        background: #e0e2e4;

        & > * {
            pointer-events: none;
        }
    }
}
</style> 